import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subject, Subscription } from 'rxjs';
import {filter, map, takeUntil} from 'rxjs/operators';
import { EventData } from '@signature-it/ngx-generic/classes';

@Injectable({
    providedIn: 'root'
})
export class EventBusService {
    private subject$ = new Subject();

    constructor() { }

    emit(event: EventData) {
        this.subject$.next(event);
    }

    on(eventName: string, action: any, destroyRef = null): Subscription {
        if (destroyRef) {
            return this.subject$.pipe(
                takeUntilDestroyed(destroyRef),
                filter((e: EventData) => e.name === eventName),
                map((e: EventData) => e.value)).subscribe(action);
        }
        return this.subject$.pipe(
            filter( (e: EventData) => e.name === eventName),
            map( (e: EventData) => e.value)).subscribe(action);
    }
}
